import * as localStorageKeys from 'constants/localStorageKeys'
import {
    SET_CONFIGURATION
} from 'services/Configuration/constants/actionTypes'
import {
    SET_USER_ID,
    SET_SESSION_DATA
} from 'components/App/constants/actionTypes'
import {
    SHOPPING_LIST_CREATE_LIST,
    SHOPPING_LIST_CREATE_ITEM,
    SHOPPING_LIST_EDIT_ITEM,
    SHOPPING_LIST_DELETE_ITEM,
    SHOPPING_LIST_CLEAR_ITEMS
} from 'components/Items/constants/actionTypes'
import getItemsLocalStorageKey from 'helpers/getItemsLocalStorageKey'
import { initializeList } from 'components/Items/actions'


export default ({ getState, dispatch }) => next => (action) => {
    const result = next(action)
    const nextState = getState()

    switch (action.type) {
        case SHOPPING_LIST_CREATE_LIST:
        case SHOPPING_LIST_CREATE_ITEM:
        case SHOPPING_LIST_EDIT_ITEM:
        case SHOPPING_LIST_DELETE_ITEM:
            localStorage.setItem(
                getItemsLocalStorageKey(),
                JSON.stringify(nextState.items)
            )

            break

        case SHOPPING_LIST_CLEAR_ITEMS:
            localStorage.removeItem(getItemsLocalStorageKey())
            break

        case SET_SESSION_DATA:
            localStorage.setItem(
                localStorageKeys.SESSION,
                JSON.stringify(nextState.app.session)
            )

            break

        case SET_USER_ID:
            localStorage.setItem(
                localStorageKeys.USER_ID,
                nextState.app.userId
            )

            break

        case SET_CONFIGURATION: {
                // TODO these items are grabbed for backward compatibility, should be skipped eventually
                const oldItems = localStorage.getItem(localStorageKeys.ITEMS)

                if (oldItems) {
                    localStorage.removeItem(localStorageKeys.ITEMS)
                    localStorage.setItem(getItemsLocalStorageKey(), oldItems)
                }

                // adding items from the partner-specific localstorage
                const items = JSON.parse(oldItems) || JSON.parse(localStorage.getItem(getItemsLocalStorageKey()))
                dispatch(initializeList(items))
            }

            break

        default:
            break
    }

    return result
}
